/**
 * SVG path data for the logo dot icon.
 */
export const logoDot = {
    paths: [
        {
            d: 'M30 16a14 14 0 1 0-28 0 14 14 0 0 0 28 0z',
            fill: 'currentColor',
            opacity: 0.1,
        },
        {
            d: 'M22 16a6 6 0 1 0-12 0 6 6 0 0 0 12 0z',
            fill: 'currentColor',
        },
    ],
    viewBox: '0 0 32 32',
    fill: 'none',
};
//# sourceMappingURL=logo-dot.js.map